import React, { useState, useEffect } from "react";
import { useMsal } from '@azure/msal-react';
import AaysLogo from "../../assets/img/Aays.png";
import { LogOut } from 'lucide-react';

const AppHeader = () => {
  const { instance, accounts } = useMsal();
  const [userName, setUserName] = useState("");
  const [initials, setInitials] = useState("");
    const [openMenu, setOpenMenu] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const account = accounts && accounts.length > 0 ? accounts[0] : null;
  useEffect(() => {
    const storedName = localStorage.getItem("userName") || "User";
    setUserName(storedName);
    // Generate initials from the name
    const nameParts = storedName.trim().split(" ");
    if (nameParts.length >= 2) {
      setInitials(nameParts[0][0].toUpperCase() + nameParts[nameParts.length - 1][0].toUpperCase());
    } else if (nameParts.length === 1 && nameParts[0]) {
      setInitials(nameParts[0].substring(0, 2).toUpperCase());
    } else {
      setInitials("U");
    }
  }, []);

  // Outside click handler for menu
  useEffect(() => {
    if (!openMenu) return;
    const handleClickOutside = (event) => {
      // Check if click is outside the profile menu area
      if (
        !event.target.closest('.appheader-profile-menu') &&
        !event.target.closest('.appheader-profile-trigger')
      ) {
        setOpenMenu(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openMenu]);
    const handleLogout = () => {
    instance.logoutRedirect();
  };

  return (
<header className="w-full bg-white shadow-[0_10px_30px_rgba(0,0,0,0.25)] border-b border-gray-200 relative z-50">      <div className="flex items-center justify-between px-6 py-3 w-[90%] mx-auto">

        {/* Left Side Image */}
        <div className="flex items-center">
        <img src={AaysLogo} alt="Logo" className="h-10 object-contain" />
        </div>

        {/* Right Side Profile */}
        <div
          onClick={() => setOpenMenu(!openMenu)}
          className="flex items-center gap-3 cursor-pointer appheader-profile-trigger"
        >
          {/* Pink Circle */}
          <div  className="w-10 h-10 rounded-full bg-[#bb1ccc] flex items-center justify-center text-white font-semibold">
            {initials}
          </div>

          {/* Name */}
          <span className="text-gray-800 font-medium">
            {userName}
          </span>
           {/* Dropdown */}
            {openMenu && (
              <div className="absolute right-20 top-16 w-30 bg-white cursor-pointer rounded-md shadow-md border border-gray-400 appheader-profile-menu">
                <button
                  onClick={() => {
                    setOpenMenu(false);
                    setOpenModal(true);
                  }}
                  className="flex items-center gap-2 w-full px-4 py-2 text-sm leading-none "
                >
                  <LogOut size={16} className="align-middle" />
                  <span className='cursor-pointer'>Logout</span>
                </button>
              </div>
            )}
        </div>

      </div>
      {openModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center pointer-events-none">
          <div className="pointer-events-auto bg-white rounded-lg w-96 p-6 shadow-xl border border-gray-300">
            <h2 className="text-lg font-semibold text-gray-800 mb-2">
              Are you sure you want to logout?
            </h2>

            <p className="text-sm text-gray-600 mb-6">
              Please confirm your decision.
            </p>

            <div className="flex justify-end gap-3">
              <button
                onClick={() => setOpenModal(false)}
                className="px-4 py-2 cursor-pointer text-sm border rounded-md hover:bg-gray-100"
              >
                No
              </button>
              <button
                onClick={handleLogout}
                className="px-4 cursor-pointer py-2 text-sm bg-[#bb1ccc] text-white rounded-md "
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default AppHeader;